<template>
  <v-btn
    small
    outlined
    class="text-none kf-dl"
    :loading="busy"
    :disabled="busy || disabled"
    @click="run"
  >
    <LucideIcon name="download" :size="15" class="mr-1" />
    {{ busy ? "Preparing…" : label }}
  </v-btn>
</template>

<script>
/**
 * "Download report" — the list you are looking at, as an Excel file.
 *
 * The file is built by the server, not here: a list screen shows 10 rows at a
 * time, so exporting from the page would mean either a 10-row report or walking
 * every page. The caller passes the same filter params its own load() sends,
 * minus paging, so the file holds exactly the rows the screen was showing.
 *
 * `busy` is its own state rather than a prop because the wait is real -- a wide
 * export takes a few seconds, and a button that looks idle invites a second
 * click and a second full export.
 */
import api from "@/app-js/karrofin/api";

export default {
  name: "KfDownloadReport",
  props: {
    /** Called with no arguments; must return a promise. */
    action: { type: Function, required: true },
    label: { type: String, default: "Download report" },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { busy: false };
  },
  methods: {
    run() {
      if (this.busy) return;
      this.busy = true;
      Promise.resolve()
        .then(() => this.action())
        .then(() => {
          this.showSnakeBar("success", "Report downloaded");
        })
        .catch((err) => {
          // The body of a failed blob request is itself a blob, so the message
          // has to be unpacked before it can be shown.
          return api.downloadErrorMessage(err).then((message) => {
            this.showSnakeBar("error", message);
          });
        })
        .finally(() => {
          this.busy = false;
        });
    },
  },
};
</script>

<style scoped>
.kf-dl {
  border-color: var(--kf-border) !important;
  color: var(--kf-brand);
}
</style>
